import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import FantasyAlbum from "./images/Fantasy-Album (Medium).png";
import { Link } from 'react-router-dom';
import './Home.css';
import Butterfly1 from './images/butterflycopper.png';
import Butterfly2 from './images/butterflybluetransp1.png';
import Butterfly3 from "./images/butterflypinktransp.png";


export default function Home() {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isTitleExpanded, setIsTitleExpanded] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = FantasyAlbum;

    image.onload = () => {
      setIsImageLoaded(true);
    };

    // Simulate the title expansion effect
    setTimeout(() => {
      setIsTitleExpanded(true);
    }, 2000);

    // After the title expansion animation, show the button
    setTimeout(() => {
      setIsButtonVisible(true);
    }, 3000);

    // Call confettiButterflies function after a delay
    setTimeout(() => {
      confettiButterflies();
    }, 1500); // Adjust the delay as needed

  }, []);

  function confettiButterflies() {
    // Remove any existing canvas
    const existingCanvas = document.getElementById("canvas");
    if (existingCanvas) {
      existingCanvas.remove();
    }

    // Create and append the canvas element
    const canvas = document.createElement('canvas');
    canvas.id = "canvas";
    canvas.style.position = "absolute"; // Ensure canvas is positioned

    const confettiContainer = document.querySelector(".confetti");
    confettiContainer.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Define butterfly images
    const butterflyImages = [
      Butterfly1,
      Butterfly2,
      Butterfly3
    ];

    let confetti = [];
    const confettiCount = 25;
    const terminalVelocity = 0.05;

    function randomRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const initialCanvasWidth = 1920; 
    const minScaleFactor = 0.5; // Define a minimum scale factor
    const maxScaleFactor = 1.0; // Define a maximum scale factor 


    function randomButterflyImage() {
      return butterflyImages[Math.floor(Math.random() * butterflyImages.length)];
    }


    function initConfetti() {
      let scaleFactor = canvas.width / initialCanvasWidth;
      scaleFactor = Math.min(Math.max(scaleFactor, minScaleFactor), maxScaleFactor);

      for (let i = 0; i < confettiCount; i++) {
        setTimeout(() => {
          // Use consistent scaling for all butterflies
          const baseScale = 0.08;
          const maxScale = 0.15;
          const scale = randomRange(baseScale, maxScale) * scaleFactor;

          const direction = Math.random() < 0.5 ? 'up' : 'down';
          const velocityY = direction === 'up' ? randomRange(-1.5, -1.5) : randomRange(2, 2) * scaleFactor;

          confetti.push({
            image: randomButterflyImage(),
            position: {
              x: randomRange(0, canvas.width),
              y: randomRange(0, canvas.height)
            },
            velocity: {
              x: randomRange(-1, 1),
              y: velocityY
            },
            scale: scale,
            direction: direction
          });
        }, i * 1);
      }
    }

    function render() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      confetti.forEach((confetto, index) => {
        const butterflyImage = new Image();
        butterflyImage.src = confetto.image;

        ctx.save();

        // Gradually increase opacity
        const opacityIncrement = 0.01; // Adjust the increment to control the speed of opacity increase
        confetto.opacity = confetto.opacity ? confetto.opacity + opacityIncrement : opacityIncrement;
        ctx.globalAlpha = Math.min(confetto.opacity, 1); // Ensure opacity does not exceed 1

        ctx.translate(confetto.position.x, confetto.position.y);
        ctx.drawImage(
          butterflyImage,
          confetto.position.x - butterflyImage.width * confetto.scale / 2, // x-coordinate
          confetto.position.y - butterflyImage.height * confetto.scale / 2, // y-coordinate
          butterflyImage.width * confetto.scale,   // width
          butterflyImage.height * confetto.scale  // height
        );

        ctx.restore();

        // Apply forces to velocity
        confetto.velocity.y = Math.min(confetto.velocity.y, terminalVelocity);

        // Move confetto position
        confetto.position.x += confetto.velocity.x;
        confetto.position.y += confetto.velocity.y;

        // Delete confetto when out of frame
        if (confetto.position.y >= canvas.height && confetto.direction === 'down') confetti.splice(index, 1);
        if (confetto.position.y <= 0 && confetto.direction === 'up') confetti.splice(index, 1);

        // Loop confetto x position
        if (confetto.position.x > canvas.width) confetto.position.x = 0;
        if (confetto.position.x < 0) confetto.position.x = canvas.width;
      });

      // Fire off another round of confetti
      if (confetti.length <= 5) initConfetti();
      window.requestAnimationFrame(render);
    }

    initConfetti();
    render();
  }


  return (
    <div className='main-container'>
      <Helmet>
        <title>Landing Page</title>
        <meta name="description" content="Stay tuned for the new fantasy music alblum by Aethel Music!" />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Landing Page - Aethel Music" />
        <meta property="og:description" content="Stay tuned for the new fantasy music alblum by Aethel Music!" />
        <meta property="og:image" content="%PUBLIC_URL%/images/Fantasy-AlbumMedium.png" />
        <meta property="og:url" content="https://aethel.vercel.app/" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Landing Page - Aethel Music" />
        <meta name="twitter:description" content="Stay tuned for the new fantasy music alblum by Aethel Music!" />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/Fantasy-AlbumMedium.png" />
      </Helmet>
      <div class="confetti"></div>
      <div>
        <h1 className={`fantasy-title ${isTitleExpanded ? 'expanded' : ''}`}>
          Fantasy Album Coming Soon!
        </h1>
      </div>
      <div className="image-container">
        <img
          src={FantasyAlbum}
          alt="Fantasy Album"
          className={`image ${isImageLoaded ? 'fade-in' : ''}`}
        />

      </div>
      {isButtonVisible && (
        <Link to="./about" id='link-button' className={`button ${isButtonVisible ? 'visible' : ''}`}>
          <button>
            Website
          </button>
        </Link>
      )}

    </div>
  );
}
